import { createHOC } from 'vue-hoc';
import gql from 'graphql-tag';
import { get } from 'lodash';

import casesService from '~lib/common/providers/casesService';
import queries from '~lib/common/queries/CaseConfiguration';

import AssignmentDetails from './AssignmentDetails';

const options = {
  name: 'AssignmentDetailsContainer',
  props: {
    assignment: {
      type: Object,
      required: true,
    },
    orgData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      state: {
        loading: true,
        caseConf: undefined,
      },
    };
  },
  created() {
    this.loadCase();
  },
  watch: {
    assignment() {
      this.state.caseConf = undefined;
      this.state.loading = true;
      this.loadCase();
    },
  },
  methods: {
    fetchCaseConf(caseId) {
      return casesService.query({
        query: gql(queries.fetchById),
        variables: {
          id: caseId,
        },
        fetchPolicy: 'network-only',
      });
    },
    async loadCase() {
      const caseId = get(this, 'assignment.caseId');
      if (!caseId) {
        console.log(`Cannot load case id: ${caseId}`);
        this.state.caseConf = undefined;
        return;
      }

      try {
        const response = await this.fetchCaseConf(caseId);
        this.state.caseConf = response.data.caseConfigurations[0];
      } catch (e) {
        console.log(e);
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const renderWith = {
  props: {
    loading() {
      return this.state.loading;
    },
    caseConf() {
      return this.state.caseConf;
    },
    orgData() {
      return this.orgData;
    },
  },
  listeners: {
    openAssignmentGrades() {
      this.$router.push({
        name: 'grades',
        params: { id: this.assignment.caseId },
        query: {
          assignmentId: this.assignment.id,
          caseName: get(this.assignment, 'caseName') || get(this.state.caseConf, 'name', 'Unavailable'),
        },
      });
    },
    editAssignment() {
      this.$router.push({ name: 'assignment-editor', params: { assignmentId: this.assignment.id } });
    },
  },
};

const AssignmentDetailsContainer = createHOC(
  AssignmentDetails,
  options,
  renderWith
);
export default AssignmentDetailsContainer;
